import * as turf from "@turf/turf";

export const calculateArea = (coordinates: [number, number][]): number => {
  if (coordinates.length < 3) return 0;
  const polygon = turf.polygon([coordinates]);
  const area = turf.area(polygon);
  return area;
};

/**
 * Calculates the perimeter of a polygon from an array of coordinates
 * @param coordinates Array of [longitude, latitude] coordinates
 * @returns The perimeter length in the same units as the input coordinates
 */
export const calculatePerimeter = (coordinates: [number, number][]): number => {
  if (!coordinates || coordinates.length < 3) {
    return 0;
  }
  let perimeter = 0;
  for (let i = 0; i < coordinates.length - 1; i++) {
    const current = coordinates[i];
    const next = coordinates[(i + 1) % coordinates.length];
    const linestring: GeoJSON.Feature = {
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: [current, next],
      },
    };
    const distance = turf.length(linestring, { units: "meters" });
    perimeter += distance;
  }
  return perimeter;
};

export const calculateCentroid = (
  coordinates: [number, number][]
): [number, number] => {
  if (!coordinates || coordinates.length < 3) {
    return [0, 0];
  }
  const polygon = turf.polygon([coordinates]);
  const centroid = turf.centroid(polygon);
  return centroid.geometry.coordinates as [number, number];
};
export const calculateLength = (coordinates: [number, number][]): number => {
  if (!coordinates || coordinates.length < 2) {
    return 0;
  }
  let length = 0;
  for (let i = 0; i < coordinates.length - 1; i++) {
    const current = coordinates[i];
    const next = coordinates[(i + 1) % coordinates.length];
    const linestring: GeoJSON.Feature = {
      type: "Feature",
      properties: {},
      geometry: {
        type: "LineString",
        coordinates: [current, next],
      },
    };
    const distance = turf.length(linestring, { units: "meters" });
    length += distance;
  }
  return length;
};
